import { render } from "./BFormRadioGroup.vue?vue&type=template&id=3da7e05a&ts=true"
import script from "./BFormRadioGroup.vue?vue&type=script&lang=ts"
export * from "./BFormRadioGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__